<template>
	<div class="contL bgWhit pdb30">
		<el-menu :default-active="defaultActive" class="el-menu-vertical-demo leftnav" @open="handleOpen" @close="handleClose"
		 :router="false">
			<div class="ptitle"><i class="iconfont icon-gerenzhongxin"></i>个人中心</div>
			<el-menu-item index="1">
				<router-link to="/people/baseinfo" tag="div"><i class="iconfont icon-jibenziliao"></i>基本资料</router-link>
			</el-menu-item>
			<el-menu-item index="2">
				<router-link to="/people/nump" tag="div"><i class="iconfont icon-zhanghaobangding"></i>账号绑定</router-link>
			</el-menu-item>
			<el-menu-item index="3">
				<router-link to="/people/approve" tag="div"><i class="iconfont icon-cedaohang-kehuguanli"></i>实名认证</router-link>
			</el-menu-item>
			<el-menu-item index="4">
				<router-link to="/people/address" tag="div"><i class="iconfont icon-shouhuodizhi"></i>收货地址</router-link>
			</el-menu-item>
			<div class="ptitle"><i class="iconfont icon-yewu"></i>业务记录</div>
			<!-- <el-menu-item index="5">
				<router-link to="/people/inquiryrecord" tag="div">询价记录</router-link>
			</el-menu-item>
			<el-menu-item index="6">
				<router-link to="/people/orderrecord" tag="div">订购记录</router-link>
			</el-menu-item> -->
			<el-menu-item index="7">
				<router-link to="/people/collection" tag="div"><i class="iconfont icon-shoucang1"></i>收藏记录</router-link>
			</el-menu-item>
			<el-menu-item index="8">
				<router-link to="/people/download" tag="div"><i class="iconfont icon-iconfontzhizuobiaozhun023146"></i>下载记录</router-link>
			</el-menu-item>
			<el-menu-item index="11">
				<router-link to="/people/history" tag="div"><i class="iconfont icon-liulan"></i>浏览记录</router-link>
			</el-menu-item>
			<div class="ptitle"><i class="iconfont icon-xiaoxi"></i>系统消息</div>
			<el-menu-item index="9">
				<router-link to="/people/myinfo" tag="div"><i class="iconfont icon-xiaoxi1"></i>我的消息</router-link>
			</el-menu-item>
			<el-menu-item index="10">
				<router-link to="/people/wzgg" tag="div"><i class="iconfont icon-gonggao1"></i>网站公告</router-link>
			</el-menu-item>
		</el-menu>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				defaultActive: "",
			}
		},
		mounted() {
			var _this = this;
			var href = window.location.href;
			href = href.split("/")[href.split("/").length - 1]
			// _this.defaultActive='#/people/'+_this.navConfig[href]
		},
		watch: {
			$route(to, from) { //to:即将要跳转到的页面   from:即将离开的页面
				if (Cookies.get('mf_service_ticket') === undefined) {
					if (to.path.split('/')[1] === 'people') {
						// this.$message({
						// 	type: 'error',
						// 	message: "请先登录之后再进行收藏操作！"
						// });
						axios.post("https://sso.mfcad.com/login/jwtuserinfo", {}).then(function(res) {
							if (res.data.status < 0) {
								var url = window.location.href;
								if (url.indexOf("?") > -1) {
									url = url.split('?');
									if (url[1].split('=')[0] == 'service_ticket') {
										Cookies.set('mf_service_ticket', url[1].split('=')[1].split('#')[0],{expires: 14});
										var mf_service_ticket = url[1].split('=')[1].split('#')[0];
									}
								}
								location.href = "https://sso.mfcad.com/login/islogin?guid=3&site=part&from_url=" + url;
							}
						});
					} else if (to.path === '/') {
						this.$router.push('/')
					}
				}
			}
		},
		methods: {
			handleOpen(key, keyPath) {
				// console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				// console.log(key, keyPath);
			}
		}
	}
</script>

<style scoped="scoped">
	.ptitle {
		font-size: 16px;
		color: #444;
		font-weight: bold;
		padding: 20px 10px 10px 20px;
		line-height: 25px;
	}

	.pure-menu-list {
		margin: 0px;
	}

	.nav-item {
		line-height: 25px;
		color: #444;
	}

	.nav-item a:hover {
		cursor: pointer;
		color: #005dbe;
	}

	.router-link-exact-active {
		color: #fbfbfb;
		background: #005dbe;
		font-weight: bold;

	}

	.el-menu-item,
	.el-submenu__title {
		height: 40px !important;
		line-height: 40px !important;

	}

	.icon-gerenzhongxin,
	.icon-yewu,
	.icon-xiaoxi {
		font-size: 24px;
		vertical-align: middle;
	}

	.router-link-exact-active>i {
		color: #FFFFFF;
	}

	.icon-yewu,
	.icon-jibenziliao,
	.icon-zhanghaobangding,
	.icon-cedaohang-kehuguanli,
	.icon-shouhuodizhi,
	.icon-shoucang1,
	.icon-iconfontzhizuobiaozhun023146,
	.icon-liulan,
	.icon-xiaoxi1,
	.icon-gonggao1 {
		font-size: 22px;
		vertical-align: middle;
		padding-right: 5px;
	}
</style>
<style>
	.leftnav .el-menu-item {
		padding-left: 0px !important;
		padding-right: 0px !important;
	}

	.leftnav .el-menu-item div {
		padding-left: 40px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue